import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  input,
  model,
  output,
  untracked,
} from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AgentBioUpdateDto } from '@workspace/data-types';

@Component({
  selector: 'etxe-agent-bio-form',
  imports: [MatFormFieldModule, MatInputModule],
  templateUrl: './agent-bio-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentBioFormComponent {
  readonly bio = model<string>('');
  readonly label = input<string | undefined>(undefined);
  readonly validityChanged = output<boolean>();
  readonly dtoChanged = output<{ dto: AgentBioUpdateDto; changed: boolean }>();

  readonly charCount = computed(() => (this.bio() || '').length);
  readonly isValid = computed(() => this.charCount() <= 1000);

  private initialBio: string | null = null;

  constructor() {
    effect(() => {
      const current = this.bio() || '';
      if (this.initialBio === null) {
        this.initialBio = current;
      }
      const valid = this.isValid();
      const changed = current !== this.initialBio;
      untracked(() => {
        this.validityChanged.emit(valid);
        this.dtoChanged.emit({
          dto: { bio: current },
          changed,
        });
      });
    });
  }

  onChange(val: string): void {
    this.bio.set(val);
  }
}
